import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import { fetchOnsiteInterviews } from '../../../../../../services/onsiteInterview';

const ROWS_PER_PAGE = 15;

export const InterviewStatus = {
  ALL: 'all',
  OPEN: 'open',
  PENDING: 'pending',
  FILLED: 'filled',
  CANCELLED: 'cancelled',
  COMPLETE: 'complete',
};

export const interviewStatusOptions = [
  { code: InterviewStatus.ALL, name: 'All' },
  { code: InterviewStatus.OPEN, name: 'Open' },
  { code: InterviewStatus.PENDING, name: 'Pending' },
  { code: InterviewStatus.FILLED, name: 'Filled' },
  { code: InterviewStatus.CANCELLED, name: 'Cancelled' },
  { code: InterviewStatus.COMPLETE, name: 'Complete' },
];

export const useOnsiteInterviews = (jobId) => {
  const [filter, setFilter] = useState({
    status: InterviewStatus.ALL,
    page: 1,
    limit: ROWS_PER_PAGE,
    sortField: 'created',
    sortOrder: 'desc',
  });

  const {
    data: response,
    isLoading,
    isError,
    error,
    refetch,
  } = useQuery({
    queryKey: ['getOnsiteInterviews', jobId, filter],
    queryFn: () => fetchOnsiteInterviews(jobId, filter),
    retry: false,
  });

  const data = response?.data || [];
  const total = response?.total || 0;
  const totalPages = Math.ceil(total / ROWS_PER_PAGE) || 1;

  const handleStatusChange = (status) => {
    setFilter((prev) => ({ ...prev, status, page: 1 }));
  };

  const handlePageChange = (page) => {
    setFilter((prev) => ({ ...prev, page }));
  };

  const handleSort = (column, direction) => {
    setFilter((prev) => ({
      ...prev,
      sortField: column.sortField,
      sortOrder: direction,
    }));
  };

  return {
    data,
    totalFiltered: total,
    totalPages,
    filter,
    error,
    isError,
    isLoading,
    handleStatusChange,
    handlePageChange,
    handleSort,
    refetch,
  };
};
